(function() {
  const bar = document.getElementById('sticky-atc-bar');
  const btn = document.getElementById('sticky-atc-btn');
  const originalAtcBtn =
    document.querySelector('button[type="submit"].button.w-full') ||
    document.querySelector('[name="add"]') ||
    document.querySelector('button[type="submit"]');

  if (!bar || !originalAtcBtn) return;

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    });
  }, { threshold: 0 });

  observer.observe(originalAtcBtn);

  // 初期表示時にGO SUBの価格で上書き
  function syncPriceOnLoad() {
    let attempts = 0;
    const interval = setInterval(function() {
      attempts++;
      const price = bar.querySelector('.sticky-atc-bar__price');
      const gosubPrice = document.querySelector('.gosub-new-price-banner');
      if (gosubPrice && gosubPrice.textContent.trim()) {
        price.textContent = gosubPrice.textContent.trim();
        clearInterval(interval);
      }
      if (attempts >= 20) clearInterval(interval);
    }, 200);
  }
  syncPriceOnLoad();




  // GO SUBの価格表示を監視してスティッキーバーに反映
  function watchGosubPrice() {
    const gosubPrice = document.querySelector('.gosub-new-price-banner');
    if (!gosubPrice) return;

    const priceObserver = new MutationObserver(function() {
      const price = bar.querySelector('.sticky-atc-bar__price');
      if (price && gosubPrice.textContent.trim()) {
        price.textContent = gosubPrice.textContent.trim();
      }
    });

    priceObserver.observe(gosubPrice, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // DOM読み込み後にGO SUB価格監視を開始
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchGosubPrice);
  } else {
    watchGosubPrice();
  }

  // バリアント変更に追従
  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant) {
      btn.dataset.variantId = e.detail.variant.id;
      const price = bar.querySelector('.sticky-atc-bar__price');
      if (price) {
        setTimeout(function() {
          const gosubPrice = document.querySelector('.gosub-new-price-banner');
          if (gosubPrice && gosubPrice.textContent.trim()) {
            price.textContent = gosubPrice.textContent.trim();
          } else {
            price.textContent = formatMoney(e.detail.variant.price);
          }
        }, 300);
      }
    }
  });

    // GO SUBの配送頻度変更に追従
  document.addEventListener('change', function(e) {
    if (e.target && e.target.closest('[class*="gosub"]')) {
      setTimeout(function() {
        const price = bar.querySelector('.sticky-atc-bar__price');
        const gosubPrice = document.querySelector('.gosub-new-price-banner');
        if (price && gosubPrice && gosubPrice.textContent.trim()) {
          price.textContent = gosubPrice.textContent.trim();
        }
      }, 300);
    }
  });


  // GO SUBのselling_plan IDを取得
  function getSellingPlanId() {
    const input = document.querySelector('[data-gosub-selling-plan-id-input]');
    return input ? input.value : null;
  }

  // カートに追加
  btn.addEventListener('click', function() {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const sellingPlanId = getSellingPlanId();

    btn.textContent = '追加中...';
    btn.disabled = true;

    const payload = { id: variantId, quantity: 1 };
    if (sellingPlanId) {
      payload.selling_plan = sellingPlanId;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.textContent = '✓ 追加しました';
      setTimeout(function() {
        btn.textContent = 'カートに追加';
        btn.disabled = false;
      }, 2000);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(function() {
      btn.textContent = 'カートに追加';
      btn.disabled = false;
    });
  });

  function formatMoney(cents) {
    return '¥' + (cents / 100).toLocaleString('ja-JP');
  }
})();
